export default __webpack_public_path__ + "static/media/CustoImage (4).4ecc09f1.png";